// Protected route dla panelu handlowca - wymaga ROLE_TRADER / ROLE_TRADER_MANAGER,
// w trakcie ładowania profilu pokazuje loader

import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { Loader } from 'components/controls';
import useRoutes from 'routes/useRoutes';

// todo zmienić ROLE_ADMIN na ROLE_TRADER po skończonych testach
const TRADER_ALLOWED_ROLES = ['ROLE_ADMIN', 'ROLE_TRADER_MANAGER'];

const TraderPanelProtectedRoute = () => {
  const { isProfileLoading, profile } = useRoutes();

  if (isProfileLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh'
        }}>
        <Loader />
      </div>
    );
  }

  if (!profile?.role || !TRADER_ALLOWED_ROLES.includes(profile.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default TraderPanelProtectedRoute;
